import styled from "styled-components";

import { AuthModalButtonContainer } from "../../../../atoms/AuthModalButton/styles";
import { AuthModalInputContainer } from "../../../../atoms/AuthModalInput/styles";

export const AuthModalRegisterFormContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding-bottom: 1.25rem;

  ${AuthModalButtonContainer} {
    width: 100%;
  }

  .auth-modal-register-form-already-have-account {
    font-weight: 400;
    gap: 0.25rem;
    padding: 0;
    height: auto;

    b {
      font-weight: 500;
    }
  }
`;

export const AuthModalRegisterForm = styled.form`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;

  gap: 0.75rem;

  overflow-y: auto;
  max-height: 50vh;
  padding: 0.25rem;

  &::-webkit-scrollbar {
    width: 4px;
    display: block;
  }

  &::-webkit-scrollbar-track {
    width: 4px;
    display: block;
  }

  &::-webkit-scrollbar-thumb {
    width: 4px;
    display: block;
  }
`;

export const AuthModalRegisterFormUserName = styled.div`
  display: flex;
  flex-direction: column;

  gap: 0.75rem;

  width: 100%;

  ${AuthModalInputContainer} {
    width: 100%;
  }

  @media screen and (min-width: 600px) {
    flex-direction: row;

    ${AuthModalInputContainer} {
      width: calc(50% - (0.75rem / 2));
    }
  }
`;

export const AuthModalRegisterButtonContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  margin-top: 1.25rem;

  [data-testid="btn-register"] {
    box-shadow: 0px 2px 40px 0px #00000040;
  }
`;
